module.exports = __webpack_public_path__ + "static/media/S3N7-5.acc5cf84.svg";